import React from 'react';
import { cn } from '../../utils/cn';
import useTranslation from '../../hooks/useTranslation';

const LoadingState = ({
  message,
  className,
  heightClassName = 'min-h-screen',
  spinnerSize = 'h-12 w-12',
}) => {
  const { t } = useTranslation(['common']);
  const resolvedMessage = message ?? t('status.loading', 'Loading…');

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center text-muted-foreground',
        heightClassName,
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <span
        aria-hidden="true"
        className={cn(
          'rounded-full border-4 border-muted-foreground/20 border-t-primary animate-spin',
          spinnerSize,
        )}
      />
      {resolvedMessage ? (
        <p className="mt-4 text-sm font-medium text-muted-foreground">{resolvedMessage}</p>
      ) : null}
    </div>
  );
};

export default LoadingState;
